import { DateTime } from "luxon"

import { HourlyMetricsCardEntryDTO } from "../DTOs/Dashboards/HourlyMetricsCardEntryDTO"
import { MaterialMovementCardDataDTO } from "../DTOs/Dashboards/MaterialMovementCardDataDTO"
import ImportCheckCardDataDTO from "../DTOs/Dashboards/ImportCheckCardDataDTO"
import PlantStatusCardDataDTO from "../DTOs/Dashboards/PlantStatusCardDataDTO"
import { TripleShift } from "../types/Shift"
import { ajaxController } from "./controller/AjaxController"

class DashboardsAjax {
  private _ajaxController = ajaxController
  private _dashboardsDataEndpoint = "/Dashboards"

  public getMaterialMovementCardData(date: DateTime, shift: TripleShift) {
    return this._ajaxController.get<MaterialMovementCardDataDTO>(
      `${this._dashboardsDataEndpoint}/material-movement/${date.toISODate()}/${shift[0]}`,
      {}
    )
  }

  public getPlantStatusCardData(date: DateTime, shift: TripleShift) {
    return this._ajaxController.get<PlantStatusCardDataDTO>(
      `${this._dashboardsDataEndpoint}/plant-status/${date.toISODate()}/${shift[0]}`,
      {}
    )
  }

  public getImportCheckCardData(date: DateTime) {
    return this._ajaxController.get<ImportCheckCardDataDTO>(
      `${this._dashboardsDataEndpoint}/import-checks/${date.toISODate()}`,
      {}
    )
  }

  public getHourlyMetricsCardData(date: DateTime, shift: TripleShift, plantTypeId: number) {
    return this._ajaxController.get<HourlyMetricsCardEntryDTO[]>(
      `${this._dashboardsDataEndpoint}/hourly-metrics`,
      {
        shiftDate: date.toISODate(),
        dayNightOrAfternoon: shift[0],
        plantTypeId
      }
    )
  }
}

export const dashboardsAjax = new DashboardsAjax();